module.exports = __webpack_public_path__ + "img/g5_linjianqingfeng.7291af7f.jpg";